import { render, staticRenderFns } from "./index.vue?vue&type=template&id=da7229f0&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Projects\\008-QLK_FE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da7229f0')) {
      api.createRecord('da7229f0', component.options)
    } else {
      api.reload('da7229f0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=da7229f0&", function () {
      api.rerender('da7229f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/index.vue"
export default component.exports